// Instance-specific logo imports
import defaultLogo from '@/assets/img/logo.png';
import cleverSaludLogo from '@/assets/img/CleverSalud.png';
import cleverGroupLogo from '@/assets/img/CleverGroup.png';

// Logo mapping by instance name
const logoMap = {
  'CleverSalud': cleverSaludLogo,
  'CleverGroup': cleverGroupLogo,
  'default': defaultLogo,
};

// Background color mapping by instance name
const backgroundColorMap = {
  'CleverSalud': '#E85D3F',
  'CleverGroup': '#E85D3F',
  'default': '#003B5C',
};

// Get the logo and background color based on instance name
const instanceName = process.env.VUE_APP_INSTANCE_NAME || 'default';
const logo = logoMap[instanceName] || logoMap.default;
const menuBackgroundColor = backgroundColorMap[instanceName] || backgroundColorMap.default;

// Centralized configuration for all environment variables
export default {
  // Instance Configuration
  instance: {
    name: instanceName,
  },

  // API Configuration
  api: {
    url: process.env.VUE_APP_API_URL,
  },

  // JWT Configuration
  jwt: {
    key: process.env.VUE_APP_JWT_KEY,
  },

  // OTP Configuration
  otp: {
    retryTimeout: parseInt(process.env.VUE_APP_OTP_RETRY_TIMEOUT) || 60,
  },

  // Support Configuration
  support: {
    email: process.env.VUE_APP_SUPPORT_EMAIL,
  },

  // Theme Configuration
  theme: {
    menuBackgroundColor: menuBackgroundColor,
  },

  // Branding Configuration
  branding: {
    logo: logo,
    copyrightText: process.env.VUE_APP_COPYRIGHT_TEXT || 'SafeTech Solution 2024',
  },
};
